module.exports = __webpack_public_path__ + "img/feat-address.svg";